import {
  FETCH_REPORTES_TERMINAL,
  FETCH_TIPO_REPORTES,
  FETCH_ULTIMO_REPORTE_PISTOLA,
  FILTRA_REPORTES_PISTOLAS,
  REGISTRA_REPORTE,
} from "./types";
import http from "./../../components/services/httpService";
import config from "./../../config.json";
import { toast } from "react-toastify";
import _ from "lodash";
import { error } from "jquery";

export const registraReporte =
  (titulo, descripcion, pistolaId, deshabilita, tipoId, adjuntos) =>
  async (dispatch, getState) => {
    const usuarioId = getState().auth.userData.id;
    const terminalId = getState().auth.userData.terminalId;
    const url = config.endPoints.registraReporte;
    const dataApi = {
      titulo,
      descripcion,
      usuarioId,
      pistolaId,
      terminalId,
      deshabilita,
      tipoId,
    };

    http
      .post(url, dataApi)
      .then(({ data }) => {
        const { msg, reporteId } = data;
        toast.success(msg);
        if (adjuntos.length > 0) {
          const formData = new FormData();
          adjuntos.forEach((foto) => {
            formData.append("fotos", foto);
          });
          const urlUpload = `${config.endPoints.uploadFotosReporte}/${reporteId}`;

          http
            .post(urlUpload, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then(({ data }) => {
              toast.success("Imagenes subidas correctamente.");
              console.log("data upload: ", data);
            })
            .catch((error) => {
              console.log("Error upload: ", error);
            });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          `Ha ocurrido un error al intetar registrar el reporte, por favor intente nuevamente.`
        );
      });
  };

export const fetchReportesPistolasTerminal =
  () => async (dispatch, getState) => {
    const terminalId = getState().auth.userData.terminalId;
    const url = `${config.endPoints.fetchReportesPistolasTerminal}/${terminalId}`;
    http
      .get(url)
      .then(({ data }) => {
        console.log("reportes: ", data);
        dispatch({
          type: FETCH_REPORTES_TERMINAL,
          payload: data,
        });
      })
      .catch((error) => {
        toast.error(
          "Ha ocurrido un error al intentar obtener los reportes de las pistolas."
        );
        console.log(error);
        dispatch({
          type: FETCH_REPORTES_TERMINAL,
          payload: [],
        });
      });
  };

export const fetchReporteTipos = () => async (dispatch) => {
  const url = config.endPoints.fetchTipoReportes;
  http
    .get(url)
    .then(({ data }) => {
      dispatch({
        type: FETCH_TIPO_REPORTES,
        payload: data,
      });
    })
    .catch((error) => {
      console.log("error tipo reportes: ", error);
      toast.error(
        "Ha ocurrido un error al intentar obtener los tipos de reportes."
      );
      dispatch({
        type: FETCH_TIPO_REPORTES,
        payload: [],
      });
    });
};

export const filtraReportesPistolas =
  (filtroPistola, filtroTipo) => async (dispatch, getState) => {
    const reportesOriginal = [...getState().reportes.reportePistolasOriginal];

    let filtros = {};

    if (filtroPistola === "Todos" && filtroTipo === "Todos") {
      return dispatch({
        type: FILTRA_REPORTES_PISTOLAS,
        payload: reportesOriginal,
      });
    }

    if (filtroPistola !== "Todos") {
      filtros["pistola"] = filtroPistola;
    }

    if (filtroTipo !== "Todos") {
      filtros["tipo"] = filtroTipo;
    }

    const filtrado = _.filter(reportesOriginal, filtros);

    console.log("filtrado: ", filtrado);
    dispatch({
      type: FILTRA_REPORTES_PISTOLAS,
      payload: filtrado,
    });
  };

export const fetchUltimoReportePistola =
  (pistolaId) => async (dispatch, getState) => {
    const url = `${config.endPoints.fetchUltimoReportePistola}/${pistolaId}`;

    http
      .get(url)
      .then(({ data }) => {
        dispatch({
          type: FETCH_ULTIMO_REPORTE_PISTOLA,
          payload: data,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: FETCH_ULTIMO_REPORTE_PISTOLA,
          payload: [],
        });
      });
  };
